module.exports = __webpack_public_path__ + "img/af.af0b97737.svg";